import React from 'react'
import First_Pane from './Blocks/First_Pane'
import Second_Pane from './Blocks/Second_Pane'

import Layout from './../Layout'


const Portfolio = () => {
  return (
    <Layout>
        <First_Pane/>
       <Second_Pane />
        
    </Layout>
  )
}

export default Portfolio